function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ZonedDateTime, isSameDay, getLocalTimeZone, today, DateFormatter } from "@internationalized/date";
import { createElement, useMemo, forwardRef } from "react";
import { StarBorder, TodayOutlined } from "sprout-ui-icons";
import { Flex, Text } from "sprout-ui-primitives";
import { SelectableWrapper } from "../Selectables";
const DateQueryResult = /*#__PURE__*/ forwardRef(function DateQueryResultForwardRef(props, ref) {
    const { date , locale  } = props, rest = _objectWithoutProperties(props, [
        "date",
        "locale"
    ]);
    const { icon , label  } = useMemo(()=>{
        const timezone = getLocalTimeZone();
        const todayDate = today(timezone);
        const isToday = isSameDay(todayDate, date);
        return {
            icon: isToday ? StarBorder : TodayOutlined,
            label: isToday ? "Today" : new DateFormatter(locale, {
                weekday: "short",
                day: "numeric",
                month: "short",
                year: "numeric"
            }).format(date.toDate(timezone))
        };
    }, [
        date,
        locale
    ]);
    const timeToRender = useMemo(()=>{
        if (!(date instanceof ZonedDateTime)) return undefined;
        return new DateFormatter(locale, {
            hour: "numeric",
            minute: date.minute ? "numeric" : undefined,
            hour12: true
        }).format(date.set({
            minute: date.minute,
            hour: date.hour
        }).toDate()).split(" ").join("").toLowerCase();
    }, [
        date,
        locale
    ]);
    return /*#__PURE__*/ _jsxs(SelectableWrapper, _objectSpread({
        ref: ref
    }, rest, {
        children: [
            /*#__PURE__*/ _jsx(Flex, {
                width: "24px",
                height: "24px",
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ createElement(icon)
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                flex: "1",
                minWidth: "0",
                ml: 3,
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        fontSize: "15px",
                        truncate: true,
                        fontWeight: "medium",
                        children: label
                    }),
                    timeToRender && /*#__PURE__*/ _jsx(Text, {
                        fontSize: "15px",
                        fontWeight: "medium",
                        children: timeToRender
                    })
                ]
            })
        ]
    }));
});
export default DateQueryResult;
